import React from "react";

function RootDots({ count, kind }) {
  const n = Math.max(0, Math.min(5, Number(count) || 0));
  return <div className={`rr-root-dots ${kind}`}>{Array.from({length:5}).map((_,i)=><i key={i} className={i<n?"filled":""}/>)}</div>;
}

export default function SupportProfile({ rootCount, pathwayCount, deepCount, affords, constrains, supportTier }) {
  const total = Math.max(1, affords + constrains);
  return (
    <section className="rr-investigation-block">
      <div className="rr-block-head"><div><span className="v25a-eyebrow">2 · HOW BROAD IS THE SUPPORT?</span><h4>Support profile</h4></div></div>
      <div className="rr-support-grid">
        <div className="rr-support-depth">
          <span className="v25a-eyebrow">INDEPENDENT ROOT DEPTH</span>
          <RootDots count={rootCount} kind={supportTier.kind}/>
          <b>{rootCount ?? "—"} independent {rootCount===1?"StudyRoot":"StudyRoots"}</b>
          <small>{supportTier.kind==="single"?"traceable · not convergent":supportTier.kind==="multi"?"multi-root support":"support depth unclassified"}</small>
        </div>
        <div className="rr-support-metrics"><div><b>{pathwayCount ?? "—"}</b><span>materialized pathways</span></div><div><b>{deepCount ?? "—"}</b><span>deep relational pathways</span></div></div>
      </div>
      {(affords+constrains)>0 ? <div className="rr-orientation-profile">
        <div className="rr-orientation-labels"><span><b>{affords}</b> affords</span><span><b>{constrains}</b> constrains</span></div>
        <div className="rr-orientation-track"><i className="affords" style={{width:`${(affords/total)*100}%`}}/><i className="constrains" style={{width:`${(constrains/total)*100}%`}}/></div>
      </div>:null}
    </section>
  );
}
